/*
 * Per-item "Add to cart" buttons for the Product Add-ons section.
 * Each add-on row already has a hidden .js-addon-variant checkbox carrying the
 * variant id (used by the main-form bundle flow). Here we inject an independent
 * "Add to cart" button under each row that adds just that one item to the cart
 * and refreshes the cart drawer (falls back to /cart if there's no drawer).
 */
(function () {
    if (window.__addonAddBound) return;
    window.__addonAddBound = true;

    function ready(fn) {
        if (document.readyState !== "loading") fn();
        else document.addEventListener("DOMContentLoaded", fn);
    }

    function addToCart(id, btn) {
        var cart = document.querySelector("cart-sidebar") || document.querySelector("cart-drawer");
        var prev = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Adding…";

        var body = new FormData();
        body.append("items[0][id]", id);
        body.append("items[0][quantity]", 1);
        if (cart && cart.getSectionsToRender) {
            body.append("sections", cart.getSectionsToRender().map(function (s) { return s.id; }));
            body.append("sections_url", window.location.pathname);
        }

        var config = typeof fetchConfig === "function" ? fetchConfig("javascript") : { method: "POST", headers: {} };
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = body;

        fetch(routes.cart_add_url, config)
            .then(function (r) { return r.json(); })
            .then(function (res) {
                if (res.status) { btn.textContent = "Unavailable"; return; }
                if (cart && res.sections && cart.renderContents) {
                    cart.renderContents(res);
                } else {
                    window.location.href = (window.routes && routes.cart_url) || "/cart";
                    return;
                }
                btn.textContent = "Added ✓";
                setTimeout(function () { btn.disabled = false; btn.textContent = prev; }, 1600);
            })
            .catch(function () { window.location.reload(); });
    }

    ready(function () {
        var sections = document.querySelectorAll(".product-addons");
        sections.forEach(function (section) {
            section.querySelectorAll(".colour-addons__item, .warranty-addons__item").forEach(function (item) {
                if (item.querySelector(".addon-add-btn")) return;
                var cb = item.querySelector(".js-addon-variant");
                if (!cb) return;
                var btn = document.createElement("button");
                btn.type = "button";
                btn.className = "addon-add-btn";
                var soldout = cb.disabled || item.classList.contains("is-soldout");
                if (soldout || !cb.value) {
                    btn.disabled = true;
                    btn.textContent = soldout ? "Sold out" : "Unavailable";
                } else {
                    btn.textContent = "Add to cart";
                    btn.dataset.variant = cb.value;
                }
                item.appendChild(btn);
            });

            section.addEventListener("click", function (e) {
                var btn = e.target.closest(".addon-add-btn");
                if (!btn || btn.disabled || !btn.dataset.variant) return;
                e.preventDefault();
                addToCart(btn.dataset.variant, btn);
            });
        });
    });
})();
